import z from "zod";

import { GetSurveyParticipantsQuery } from "@performyard/service-contracts";

export const PARTICIPANT_PAGE_SIZE = 25;

export const searchParamsSchema = GetSurveyParticipantsQuery.omit({ limit: true, offset: true }).extend({
	employeeId: z.string().optional(),
});

export type SearchParams = z.infer<typeof searchParamsSchema>;
